/* eslint-disable react/prop-types */
import React from "react";
import Header from "../Components/Simulation/Header";
import Navbar from "../Components/Simulation/Navbar";
import Page from "../Components/Simulation/Page";
import { AGE_DEPART_RETRAITE } from "../Config/config";
import { regexRemoveSpaces } from "../Config/utils";
import { updateAge } from "../Store/store";

function checkData(value) {
  const numerousValue = parseInt(regexRemoveSpaces(value));

  return numerousValue >= 18 && numerousValue < AGE_DEPART_RETRAITE;
}

export default function Age(props) {
  return (
    <div className="page-container">
      <Header pageIndex={props.pageIndex} totalPages={props.totalPages} />
      <Navbar pageIndex={props.pageIndex} totalPages={props.totalPages} />
      <Page
        title="Quel âge avez-vous ?"
        subtitle="Pour identifier les meilleurs dispositifs"
        pageType="input"
        type="numerous"
        placeholder="Ex: 38"
        reduxAction={updateAge}
        reduxStateName="age"
        checkData={checkData}
        dataType="integer"
        myNameDb="age"
        pageIndex={props.pageIndex}
        totalPages={props.totalPages}
      />
    </div>
  );
}
